<template>
  <material-card
    :title="$t('components.portalcoverage.coverageinfo.section_title')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="subject"
  >
    <v-card-text>
      {{ $t("components.portalcoverage.coverageinfo.helptext") }}
    </v-card-text>
    <v-card-text v-if="coverageInfo !== null && coverageInfo !== undefined">
      <v-form :disabled="loading" ref="form" v-model="valid">
        <v-container>
          <div class="row">
            <div class="col-12 col-md-12">
              <trans-textbox
                :label="$t('globals.title')"
                v-model="coverageInfo"
                :rules="[$rules.required]"
                field="Title"
                class="required"
              />
            </div>
            <div class="col-12">
              <trans-texteditor
                v-model="coverageInfo"
                :label="$t('headers.news.text')"
                field="Html"
              ></trans-texteditor>
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        @click="save()"
        :disabled="!valid"
      >
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import TransTexteditor from "../../components/TransTexteditor";
import TransTextbox from "../../components/TransTextbox";

export default {
  components: {
    ErrorHandler,
    TransTexteditor,
    TransTextbox,
  },
  data: () => ({
    valid: false,
    coverageInfo: null,
    loading: false,
    error: null,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions("downloadCenter", ["saveCoverageInfo", "getCoverageInfo"]),
    async save() {
      try {
        let item = JSON.parse(JSON.stringify(this.coverageInfo));
        for (let trans of item.Translations) {
          if (trans.Image) {
            trans.ImageId = trans.Image.Id;
          }
          delete trans.Image;
        }
        item.PlanId = this.selectedPlan.Id;
        await this.withLoad(this.saveCoverageInfo(item));
      } catch (e) {
        this.error = e;
      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
    async load() {
      try {
        this.loading = true;
        const resp = (await this.getCoverageInfo(this.selectedPlan.Id)).value;
        if (resp.length > 0) {
          this.coverageInfo = resp[0];
        } else {
          this.coverageInfo = {};
        }
      } catch (e) {
        this.error = e;
      }
      this.loading = false;
    },
  },
};
</script>
